import { ApolloLink, Observable } from "@apollo/client";

export const EMERGENCY_CLOUD_ERROR = "Cloud is not available in emergency mode";

export function createEmergencyCloudLink(
  isEmergency: () => boolean,
): ApolloLink {
  return new ApolloLink((operation, forward) => {
    if (!isEmergency()) return forward(operation);
    return new Observable((observer) => {
      observer.error(new Error(EMERGENCY_CLOUD_ERROR));
    });
  });
}
